import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import clsx from 'clsx'

import Button from '../../utils/Button'
import { dateHasPast } from '../../utils/dateFormat'

import { fetchAvailabilityMatches } from '../../../actions/availabilityMatchesActions'
import { fetchAvailabilityRequest } from '../../../actions/availabilityRequestsActions'
import { formClone } from '../../../actions/requestFormActions'

import Details from './Details'
import Premium from '../../user/premium.js'
import Content from './Content'
import Status from './Status'
import Card from '../../utils/Card'
import { HeaderLarge as Header } from '../../utils/Header'

import Skeleton from 'react-loading-skeleton'
import { Link } from 'react-router-dom'

const ShowSegment = ({ className, children }) => <div className={clsx(className, 'w-full')}>{children}</div>

const Show = ({ match, ...props }) => {
  const dispatch = useDispatch()
  const fetching = useSelector(store => store.availabilityRequests.fetching)
  const ar = useSelector(store => store.availabilityRequests.request)
  const facility = useSelector(store => store.availabilityRequests.request.facility)

  useEffect(() => {
    dispatch(fetchAvailabilityRequest(match.params.uuid))
    dispatch(fetchAvailabilityMatches(match.params.uuid))
  }, [match.params.uuid])

  return (
    <>
      <div className="md:flex space-x-0 md:space-x-4">
        <ShowSegment className="md:w-2/3 lg:w-1/2">
          <Header
            icon={faMapMarkerAlt}
            header={<Link to={`/f/${facility.slug}`}>{facility.name}</Link>}
            subHeader={facility.sub_name}
            data-facilityId={facility.id}
          />
          {ar.uuid && ar.status === 'canceled' && (
            <Card color="gray" className="text-lg font-semibold my-4">
              This request is canceled and is no longer being checked.
              {ar.canceledReason && <p className="mt-2">{ar.canceledReason}</p>}
            </Card>
          )}
          {dateHasPast(ar.dateEnd) && (
            <Card color="gray" className="text-lg font-semibold my-4">
              This request has expired and is no longer being checked.
            </Card>
          )}
          <div className="mt-12">
            <Details />
          </div>
          <div className="flex mt-12 space-x-4">
            {ar.premium && !dateHasPast(ar.dateEnd) && (
              <Button color="green" onClick={() => dispatch(push(`/edit/${ar.uuid}`))}>
                Edit
              </Button>
            )}
            {ar.premium && (
              <Button color="green" onClick={() => dispatch(formClone())} className="hidden md:inline-block">
                Clone
              </Button>
            )}
          </div>
          <div className="flex mt-4 space-x-4">{!dateHasPast(ar.dateEnd) && <Status />}</div>
        </ShowSegment>

        <ShowSegment className="md:w-1/3 lg:w-1/2 mt-12 md:mt-0">
          <Premium />
        </ShowSegment>
      </div>
      {!fetching && <Content />}
    </>
  )
}

export default Show
